import {ThemeIconKey} from 'platform/foundation';

import {test} from 'ramda';

export function getIconKeyByFileName(name: string): ThemeIconKey {
  return test(/\.pdf$/, name) ? 'files_compact/property_PDF' : 'files_compact/property_DOC';
}
